<template>
  <!-- :value/@input allows us to pass v-model to the component in v2 -->
  <!-- :modelValue/@update:modelValue allows us to pass v-model to the component in v3 -->
  <input
    type="search"
    autocorrect="off"
    autocapitalize="off"
    autocomplete="off"
    required
    maxlength="512"
    aria-label="Search"
    :placeholder="placeholder"
    :autofocus="autofocus"
    :class="`${suit('input')} text-base font-medium ring-1 ring-inset ring-light-border-grey rounded-lg pl-14 pr-4 w-full focus:ring-1 focus:ring-inset focus:ring-light-border-grey py-[18px] placeholder:text-gray-400 placeholder:text-light-blue-2`"
    :value="modelValue"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event.target.value); $emit('update:modelValue', $event.target.value)"
    ref="input"
  >
</template>

<script>
import { createSuitMixin } from 'vue-instantsearch/vue3/es';

export default {
  name: 'SearchInput',
  mixins: [createSuitMixin({ name: 'SearchBox' })],
  compatConfig: { MODE: 3 },
  props: {
    placeholder: {
      type: String,
      default: 'Search here…',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: false,
      default: undefined,
    },
    modelValue: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  emits: ['input', 'update:modelValue', 'blur', 'focus'],
  data() {
    return {
      query: '',
    };
  },
};
</script>
